<template>
  <div style="overflow: auto">
    <div
      v-dompurify-html="safeHtml"
      class="json-block"/>
  </div>
</template>
<script>
import textFunctions from 'mixins/textFunctions'

export default {
  name: 'JsonViewer',
  mixins: [ textFunctions ],
  props: {
    value: {
      type: String,
      required: true
    },
    maxLength: {
      type: Number,
      default: 100000 // ограничение на размер строки для предотвращения зависания
    }
  },
  computed: {
    safeHtml() {
      if (!this.value || typeof this.value !== 'string') {
        return this.$_escapeHtml ? this.$_escapeHtml(this.value) : this.value
      }
      if (this.value.length > this.maxLength) {
        return '<span style="color: var(--color-error) !important">' + this.$t('JsonViewer.TooLarge', 'Слишком большой JSON для предпросмотра') + '</span>'
      }
      try {
        var jsonLine = /^( *)("[\w]+": )?("[^"]*"|[\w.+-]*)?([,[{])?$/mg
        var replacer = function(match, pIndent, pKey, pVal, pEnd) {
          var key = '<span class="json-key" style="color: var(--color-error) !important">',
            val = '<span class="json-value" style="color: var(--status-none) !important">',
            str = '<span class="json-string" style="color: olive !important">',
            r = pIndent || ''
          if (pKey) { r = r + key + pKey.replace(/[": ]/g, '') + '</span>: ' }
          if (pVal) { r = r + (pVal[0] == '"' ? str : val) + pVal + '</span>' }
          return r + (pEnd || '')
        }

        return JSON.stringify(JSON.parse(this.value), null, 3)
          .replace(/&/g, '&amp;').replace(/\\"/g, '&quot;')
          .replace(/</g, '&lt;').replace(/>/g, '&gt;')
          .replace(jsonLine, replacer)
      } catch {
        return this.$_escapeHtml(this.value)
      }
    }
  }
}
</script>
<style scoped>
.json-block {
  white-space: pre-wrap;
  max-height: 200px;
  overflow: auto;
}
.json-key {
  color: var(--color-error);
}
.json-value {
  color: var(--status-none);
}
.json-string {
  color: olive;
}
</style>
